import React, { Component } from 'react';
import { choice } from '../../demos/Helpers';
import Coin from './Coin';

class CoinContainer extends Component {
	static defaultProps = {
		coins: [
			{
				side: 'heads',
				imgSrc: 'https://i.postimg.cc/5jcwNHm2/head.png',
			},
			{
				side: 'tails',
				imgSrc: 'https://i.postimg.cc/gJJyMbJm/tail.png',
			},
		],
	};

	constructor(props) {
		super(props);
		this.state = {
			currCoin: null,
			nFlips: 0,
			nHeads: 0,
			nTails: 0,
		};
		this.handleClick = this.handleClick.bind(this);
	}

	flipCoin() {
		const newCoin = choice(this.props.coins);
		this.setState((st) => {
			return {
				currCoin: newCoin,
				nFlips: st.nFlips + 1,
				nHeads: st.nHeads + (newCoin.side === 'heads' ? 1 : 0),
				nTails: st.nTails + (newCoin.side === 'tails' ? 1 : 0),
			};
		});
	}

	handleClick() {
		this.flipCoin();
	}

	render() {
		return (
			<div className='CoinFlipper container text-center'>
				<h2>Let's Flip a coin!!!</h2>
				{this.state.currCoin && <Coin info={this.state.currCoin} />}
				<button onClick={this.handleClick}>Flip Me!!!</button>
				<p>
					Out of {this.state.nFlips} flips, there have been {this.state.nHeads}{' '}
					heads and {this.state.nTails} tails
				</p>
			</div>
		);
	}
}

export default CoinContainer;
